import classNames from 'classnames'
import { User } from '@opallabs/concepts'
import { ZIndex } from '@opallabs/gem'
import { Icon, Tooltip, Avatar } from '@opallabs/lapidary'
import { SupportedResource } from '../types'
import * as styles from './styles'

type ObjectAccessInfoProps = {
  accessTooltipContent?: string
  avatarTooltipContent?: string
  className?: string
  objectOwner?: User
  hideAccessIcon?: boolean
  isPrivate?: boolean
  resource: SupportedResource | 'board'
  showUserName?: boolean
  /**
   * Added to `@opallabs/gem` `ZIndex.Tooltip`. Only needed for scenarios where `<ObjectAccessInfo>` is rendered within
   * something that has a higher `z-index`.
   */
  tooltipZindex?: number
}

/**
 * @deprecated Prefer `PermissionsSummary` where API support for
 * effective privacy allows.
 */
export const ObjectAccessInfo: React.FC<ObjectAccessInfoProps> = ({
  accessTooltipContent,
  avatarTooltipContent,
  className,
  objectOwner,
  isPrivate = true,
  resource,
  showUserName = false,
  hideAccessIcon = false,
  tooltipZindex,
}) => {
  const defaultOwnerText = `This ${resource} is owned by ${objectOwner?.name ?? 'a deactivated user'}`
  const defaultAccessText = isPrivate
    ? `Only collaborators can access this ${resource}`
    : `Anyone in this workspace can access this ${resource}`

  return (
    <div
      className={classNames('lapidary-access-info', className)}
      css={[styles.container, styles.containerDynamic(showUserName)]}
    >
      {objectOwner && (
        <Avatar
          css={styles.avatar}
          fullName={objectOwner.name}
          size={20}
          src={objectOwner?.asset?.url}
          tooltipped={Boolean(!showUserName || avatarTooltipContent)}
          customTooltipText={avatarTooltipContent ?? defaultOwnerText}
        />
      )}
      {showUserName && (
        <span css={[styles.text, styles.textDynamic]}>
          Owned by {objectOwner?.name ?? 'a deactivated user'}
        </span>
      )}
      {!hideAccessIcon && (
        <Tooltip
          side="top"
          content={accessTooltipContent ?? defaultAccessText}
          zIndex={tooltipZindex ?? ZIndex.Drawer.Tooltip}
        >
          <span>
            <Icon glyph={isPrivate ? 'gem-locked' : 'gem-globe'} ariaHidden />
          </span>
        </Tooltip>
      )}
    </div>
  )
}
